<div class="container mt-4">
    <h1 class="page-title primary-gradiant mb-5">
        {{ "pages.sites_management.title" | translate }}
    </h1>

    <div class="table-header">
        <div class="float-end">
            <button mat-raised-button color="primary" (click)="openSiteDialog()">
                {{ "pages.sites_management.actions.add_site" | translate }}
            </button>
        </div>
    </div>

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
            <!-- Label Column -->
            <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "models.site.label" | translate }}
                </th>
                <td mat-cell *matCellDef="let site">{{ site.label }}</td>
            </ng-container>

            <!-- Unity Count Column -->
            <ng-container matColumnDef="unityCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "models.site.unity_count" | translate }}
                </th>
                <td mat-cell *matCellDef="let site">{{ site.unityCount }}</td>
            </ng-container>

            <!-- Equipment Count Column -->
            <ng-container matColumnDef="equipmentCount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "models.site.equipment_count" | translate }}
                </th>
                <td mat-cell *matCellDef="let site">{{ site.equipmentCount }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let site" class="action-buttons">
                    <button
                            mat-icon-button
                            [matMenuTriggerFor]="actionMenu"
                            (click)="selectedSite = site"
                            aria-label="Actions"
                    >
                        <mat-icon color="primary">more_vert</mat-icon>
                    </button>

                    <mat-menu #actionMenu="matMenu">
                        <button mat-menu-item (click)="navigateToImport(selectedSite!)">
                            <span>{{ 'pages.sites_management.actions.import_equipment' | translate }}</span>
                        </button>
                        <button mat-menu-item (click)="openSiteDialog(selectedSite!)">
                            <span>{{ 'general.actions.edit' | translate }}</span>
                        </button>
                        <button mat-menu-item (click)="deleteSite(selectedSite!)">
                            <span>{{ 'general.actions.delete' | translate }}</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data-cell" colspan="4">
                    <div class="no-data-message">
                        {{ "pages.sites_management.no_data" | translate }}
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>
